export const HOMEPAGE = {
  ctaButton: 'homepage-cta-daftar-button',
};

export const REGISTRATION_FORM = {
  page: 'registration-form-page',
  posterImage: 'registration-poster-image',
  closedNotice: 'registration-closed-notice',
  closedUploadLink: 'registration-closed-upload-link',
  namaInput: 'registration-nama-input',
  whatsappInput: 'registration-whatsapp-input',
  bpkelInput: 'registration-bpkel-input',
  bawaKeluargaRadioGroup: 'registration-bawa-keluarga-radio-group',
  bawaKeluargaOptionYa: 'registration-bawa-keluarga-option-ya',
  bawaKeluargaOptionTidak: 'registration-bawa-keluarga-option-tidak',
  jumlahKeluargaInput: 'registration-jumlah-keluarga-input',
  anggotaKeluargaTextarea: 'registration-anggota-keluarga-textarea',
  totalPesertaDisplay: 'registration-total-peserta-display',
  totalBayarDisplay: 'registration-total-bayar-display',
  payNowButton: 'registration-pay-now-button',
  payLaterButton: 'registration-pay-later-button',
  copyRekeningButton: 'registration-copy-rekening-button',
  whatsappAdminButton: 'registration-whatsapp-admin-button',
  whatsappAdminButtonSuccess: 'registration-whatsapp-admin-button-success',
  buktiTransferInput: 'registration-bukti-transfer-input',
  buktiTransferPreview: 'registration-bukti-transfer-preview',
  submitButton: 'registration-submit-button',
  cancelUploadModeButton: 'registration-cancel-upload-mode-button',
  errorAlert: 'registration-error-alert',
  successPage: 'registration-success-page',
  downloadInstructionBanner: 'registration-download-instruction-banner',
  downloadCardButton: 'registration-download-card-button',
  successNoPendaftaran: 'registration-success-no-pendaftaran',
  successStatusBadge: 'registration-success-status-badge',
  successUploadLink: 'registration-success-upload-link',
  successBackHomeButton: 'registration-success-back-home-button',
};

export const UPLOAD_BUKTI_PAGE = {
  page: 'upload-bukti-page',
  noPendaftaranInput: 'upload-bukti-no-pendaftaran-input',
  whatsappInput: 'upload-bukti-whatsapp-input',
  fileInput: 'upload-bukti-file-input',
  filePreview: 'upload-bukti-file-preview',
  submitButton: 'upload-bukti-submit-button',
  errorAlert: 'upload-bukti-error-alert',
  successPage: 'upload-bukti-success-page',
};

export const ADMIN_PAGE = {
  page: 'admin-page',
  searchInput: 'admin-search-input',
  statTotalPendaftar: 'admin-stat-total-pendaftar',
  statTotalPeserta: 'admin-stat-total-peserta',
  statTotalDana: 'admin-stat-total-dana',
  statSudahVerifikasi: 'admin-stat-sudah-verifikasi',
  registrasiToggle: 'admin-registrasi-toggle',
  table: 'admin-registrations-table',
  rowPrefix: 'admin-registration-row-',
  buktiThumbnailPrefix: 'admin-bukti-thumbnail-',
  buktiBelumUploadPrefix: 'admin-bukti-belum-upload-',
  verifyButtonPrefix: 'admin-verify-button-',
  verifiedBadgePrefix: 'admin-verified-badge-',
  statusBadgePrefix: 'admin-status-badge-',
  imageDialog: 'admin-image-dialog',
  emptyState: 'admin-empty-state',
};
